import React from 'react';
import { Card, CardContent, CardHeader, Grid, CircularProgress, Checkbox, Radio } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

const ColoredRadio = withStyles({
    root: {
      color: 'var(--jmi-green)',
      '&$checked': {},
    },
    checked: {},
  })(props => <Radio color="default" {...props} />);
export default ColoredRadio;